import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'
import type {
  PricingSectionSliceLargePrimaryFirstPackagePillsItem,
  PricingSectionSliceLargePrimarySecondPackagePillsItem,
  PricingSectionSliceLargePrimaryThirdPackagePillsItem,
} from 'prismicio-types'

type PricingPillProps = {
  pill:
    | PricingSectionSliceLargePrimaryFirstPackagePillsItem
    | PricingSectionSliceLargePrimarySecondPackagePillsItem
    | PricingSectionSliceLargePrimaryThirdPackagePillsItem
}

export const PricingPill = ({pill}: PricingPillProps) => {
  const isBlue = pill.color === 'Blue'

  return (
    <div
      className={cn(
        'flex h-8 items-center gap-1.5 rounded-full border border-[rgba(19,_18,_18,_0.07)] py-1 pl-2 pr-3',
        isBlue ? 'bg-ui-blue-120' : 'bg-moss-white',
      )}
    >
      {isFilled.image(pill.icon) && <PrismicNextImage field={pill.icon} className="size-4 shrink-0" />}
      <span
        className={cn(
          'whitespace-nowrap text-[12px] font-semibold uppercase tracking-[0.72px]',
          isBlue ? 'text-ui-blue-900' : 'text-moss-grey-500',
        )}
      >
        {pill.title}
      </span>
    </div>
  )
}
